import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';


class RevAthonMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {}

    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Revfin RevAthon</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>

                {/*<section className="banner_text headerbg nomar">*/}
                {/*    <div className="container">*/}
                {/*        <div className="imgRve">*/}
                {/*            <img src={require("../images/revlogo.png")} alt=''/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</section>*/}
                <section className="mainSec">
                    <div className="container">
                        <div className="gifArea">
                            <img src={require("../images/revgif.gif")} alt=''/>
                        </div>
                        <div className="revthonConteantArea">
                            <h3>WHAT IS REV-A-THON</h3>
                            <p>
                                <b>REV-A-THON is Revfin's gamification platform.</b>
                            </p>
                            <p>
                                A <span className="mainRevColor">Rev-a-Thon</span>
                                user will be able to collect POINTS (known as 'REVS') for performing certain TASKS.
                                These POINTS
                                will help users climb LEVELS. Upon reaching each new LEVEL, users will be given REWARDS.
                                REWARDS
                                can be in form of products (access to more products and/or easing of payment terms),
                                reduction in
                                pending EMIs or in kind. The purpose of Rev-a-thon is to help users become financially
                                prudent by
                                repaying their EMIs on time through the banking channel. This will help users get access
                                to more and better financial products in future.
                            </p>
                        </div>

                        <div className="SchdulBox">
                            <h3>There are four components of <span className="mainRevColor">Rev-a-thon</span></h3>
                            <p><span className="mainRevColor uppertext">Tasks</span> – TASKS are the actions that will
                                be assigned to users and they will have to perform to earn POINTS.
                            </p>
                            <p><span className="mainRevColor uppertext">Revs</span> - REVS are the POINTS that a user
                                gets for performing a certain TASK. POINTS are positive if a TASK if successfully
                                completed and are negative/punitive for non-performance of TASKS and doing undesirable
                                TASKS</p><p><span className="mainRevColor uppertext">Levels</span> – upon achieving
                            certain POINTS, a user gets promoted to the next LEVEL. Equally, a user may be demoted if
                            their POINTS go below a defined threshold.</p><p><span
                            className="mainRevColor uppertext">Rewards</span> – REWARDS are the benefits that a user
                            receives upon attaining each new LEVEL. REWARDS can be in form of product benefits,
                            reduction in pending EMIs or in kind, as notified from time to time.</p>
                        </div>


                        <div className="grafRevA">
                            <img src={require("../images/relader.jpg")} alt=''/>
                        </div>


                        <div className="revcontc">
                            <h3>TASKS AND POINTS</h3>
                            <p>POINTS will be referred to as REVS. The minimum REVS a user can have is 0. There is no
                                cap on maximum REVS a user can have. REVS will be updated every night and a user will be
                                able to their REVS based on TASKS performed by 9am the following day.</p><p>REVS are
                            given to users for several TASKS. The primary TASKS are mentioned below. In addition to the
                            list below, users may be assigned new TASKS from time to time to boost their REVS.</p>
                            <p>Revfin also reserves the right to change the TASKS, TASK description and value of the
                                REVS from time to time without notifying users.</p>
                        </div>

                        <div className="tableArea">
                            <table className="table-responsive">
                                <tr>
                                    <th>Task Name</th>
                                    <th>Task Description</th>
                                    <th>Revs</th>
                                </tr>
                                <tr>
                                    <td>Welcome</td>
                                    <td>Welcome points on NACH registration</td>
                                    <td>+200</td>
                                </tr>
                                <tr>
                                    <td>EMI payment on time</td>
                                    <td>For any loan EMI (amortising loan product) that is paid on or before due date.
                                        Only awarded to customers who are fully up to date with loan repayments
                                    </td>
                                    <td> +100</td>
                                </tr>
                                <tr>
                                    <td>EMI payment through NACH</td>
                                    <td>When loan installment is paid through direct debit (or NACH). This applies only
                                        where the full EMI is paid through direct debit for a customer’s bank account
                                        and the customer is fully up to date with their loan repayments
                                    </td>
                                    <td>+50</td>
                                </tr>
                                <tr>
                                    <td>EMI payment after missing one</td>
                                    <td>If any loan installment is missed but paid before the next installment becomes
                                        due. Only applies if one payment is due. If multiple payments are due, this does
                                        not apply
                                    </td>
                                    <td>+50</td>
                                </tr>
                                <tr>
                                    <td>6 EMIs on time</td>
                                    <td>If six continuous loan installments are paid on or before time. Only applies to
                                        customers who are fully up to date with their loan repayments
                                    </td>
                                    <td>+600</td>
                                </tr>
                                <tr>
                                    <td>Loan settled</td>
                                    <td>If a loan has been fully repaid and closed/settled. Does not apply if there is
                                        any outstanding balance on the loan
                                    </td>
                                    <td>+1000</td>
                                </tr>
                                <tr>
                                    <td>Loan written-off/closed bad</td>
                                    <td>If a loan has been written-off or closed bad or settled after being
                                        written-off
                                    </td>
                                    <td>-5000</td>
                                </tr>
                                <tr>
                                    <td>Missed EMI</td>
                                    <td>If any loan installment is not paid on time. A five-day grace period will be
                                        given to repay the installment and avoid deduction of REVS
                                    </td>
                                    <td>-50</td>
                                </tr>
                                <tr>
                                    <td>Refer a Friend</td>
                                    <td>When a user refers their friends, family or acquaintances using our specified
                                        refer code
                                    </td>
                                    <td>+500</td>
                                </tr>
                                <tr>
                                    <td>App Login</td>
                                    <td>Every time a user logs in to the Revfin App. This applies up to a maximum of
                                        four times in a month
                                    </td>
                                    <td>+50</td>
                                </tr>
                            </table>
                        </div>

                        <div className="revcontc"><h3>LEVELS AND REWARDS</h3><p>There are four LEVELS in Rev-a-thon.
                            Number of LEVELS, their names and associated REWARDS may be changed by Revfin at any time
                            without prior user notification.</p><p>Revfin reserves the right to change the LEVELS or
                            introduce new LEVELS, the REVS required for each level and the Rewards available at each
                            Level.</p></div>

                        <div className="tableArea">
                            <table className="table-responsive">
                                <tr>
                                    <th>Levels</th>
                                    <th>Revs required</th>
                                    <th>Rewards</th>
                                </tr>
                                <tr>
                                    <td>Orange</td>
                                    <td>0</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Bronze</td>
                                    <td>1000</td>
                                    <td>
                                        <ul className="listtable">
                                            <li>Revloan offered</li>
                                            <li>Revloan charges – Re.1/day for each Rs. 1,000 utilised</li>
                                            <li>500 REVS will be transferred to Customer’s Gullak (bank); can be used
                                                towards installment payment
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Silver</td>
                                    <td>2,500</td>
                                    <td>
                                        <ul className="listtable">
                                            <li>New TASKS</li>
                                            <li>750 REVS will be transferred to Customer’s Gullak (bank); can be used
                                                towards installment payments
                                            </li>
                                            <li>Revloan charges – Re. 0.80/day for each Rs. 1,000 utilised</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Gold</td>
                                    <td>5,000</td>
                                    <td>
                                        <ul className="listtable">
                                            <li>New TASKS will be given to earn more REVS</li>
                                            <li>1,000 REVS will be transferred to Customer’s Gullak (bank); can be used
                                                towards installment payments
                                            </li>
                                            <li>Revloan charges – Re. 0.60/day for each Rs. 1,000 utilised</li>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
                        </div>


                        <div className="revcontc chol"><h3>TERMS AND CONDITIONS</h3>
                            <ul className="contentLis">
                                <li>You may participate in Rev-a-thon upon successful registration and creation of an
                                    account on the Platform and shall be bound by these terms and conditions and the
                                    Revfin 'Privacy Policy' by mere usage of the Platform. "Revfin" means jointly Revfin
                                    Services Private Limited and Aristo Securities Private Limited. "Rev-a-thon" means
                                    Revfin's gamification platform.
                                </li>
                                <li>You may participate in Rev-a-thon only if you are a resident Indian who has attained
                                    18 years of age and are competent to contract.
                                </li>
                                <li>"Gullak" is your 'wallet' maintained with Revfin, in which the REVS earned/deducted
                                    shall be reflected and may be viewed by you. Gullak is a closed system available
                                    only to resident Indians who have attained the age of 18 years and are competent to
                                    contract. You are permitted to maintain and operate only one Gullak – the Gullak is
                                    not transferable/assignable and is unique to you.
                                </li>
                                <li>REVS can only be earned or accumulated by completion of TASKS. REVS cannot be
                                    purchased or acquired in manner, except completion of TASKS, as specified from time
                                    to time. REVS are non-transferable and may not be assigned to any other person in
                                    any manner. No interest will be payable by Revfin on the available
                                    REVS/POINTS/balance/REWARDS reflected in the Gullak.
                                </li>
                                <li>You hereby authorize Revfin to hold, receive, deduct and disburse REVS in/from your
                                    Gullak, in accordance with redemption instructions or policies of Revfin (including
                                    punitive deduction of REVS for non-performance of TASKS or undesirable actions). In
                                    the event of any dispute, records maintained by Revfin shall be binding as
                                    conclusive evidence, including as to REVS earned/deducted and transactions from the
                                    Gullak. Revfin may send communications by SMS and/or e-mail. You agree to receive
                                    all commercial messages including transactional messages from Revfin.
                                </li>
                                <li>REVS in the Gullak can only be redeemed towards purchase of goods or services
                                    provided by Revfin. REVS cannot be withdrawn/refunded as cash at any time or used
                                    for payments or settlement for third party goods/services. REWARDS upon redemption
                                    of REVS can be in form of products (access to more products and/or easing of payment
                                    terms), reduction in pending EMIs, or in kind (each offered only by Revfin), at the
                                    sole discretion of Revfin. The value and redemption rate for REVS shall be as
                                    decided by Revfin from time to time, at its sole discretion. Revfin reserves the
                                    right to change the TASKS, TASK description and value of the REVS for Rev-a-thon
                                    from time to time at its sole discretion, without notification. It is not possible
                                    or permissible to withdraw cash from the Gullak in any event. You agree that any
                                    REVS/outstanding balance in your Gullak shall be forfeited at the time of closure of
                                    your Loan facilitated through Revfin, for any reason whatsoever. You expressly agree
                                    and acknowledge that you shall have no claims against Revfin for the balance
                                    forfeited from Gullak.
                                </li>
                                <li>Access to the Platform, Rev-a-thon and Gullak require maintenance of a mobile phone
                                    handset/device on which the Platform can run and an active internet connection.
                                    Revfin shall not be liable for any failure/liability arising from unavailability of
                                    the Platform to you due to a deficient mobile handset or the internet services. In
                                    case your password to access the Platform or your SIM/mobile device is
                                    lost/misplaced/not in your control, you shall promptly inform Revfin by calling on
                                    the customer care numbers.
                                </li>
                                <li>Your Gullak and/or participation in Rev-a-thon may be suspended/terminated by Revfin
                                    at any time for any cause, including: (i) suspected violation of terms and
                                    conditions; (ii) discrepancy/falsification of information and/or documentation
                                    provided by you; (iii) to prevent or stop fraud, phishing, sabotage, wilful
                                    destruction, hacking, or any force majeure event; (iv) technical failure,
                                    transmission failure, infrastructure fault/failure, upgradation, variation, repair,
                                    maintenance or any emergency; (v) the mobile device/number with which the Gullak is
                                    linked ceases to the operational or in your possession and control; (vi) any other
                                    legitimate purpose. Operation of or continued availability of Rev-a-thon, Gullak
                                    and/or REVS shall be subject to requirements of applicable laws (existing or
                                    subsequently introduced).
                                </li>
                                <li>Revfin may modify, terminate and/or suspend Rev-a-thon/Gullak at any time, with or
                                    without prior notice, due to any changes in internal policies, rules, regulations,
                                    applicable laws or for any other reason, at the sole discretion of Revfin. Revfin
                                    reserves the right to modify these terms and conditions at any time by posting the
                                    latest terms and conditions on the Platform. Your continued participation in/use of
                                    Rev-a-thon, the Platform and Gullak following the posting of changes shall mean and
                                    be deemed as your acceptance of the latest terms and conditions. If you do not agree
                                    with any such change, your sole and exclusive remedy is to terminate your
                                    participation in/use of Rev-a-thon, the Platform and Gullak.
                                </li>
                                <li>Any claims against Revfin shall be governed by the laws of India and the courts at
                                    New Delhi shall have sole jurisdiction.
                                </li>
                            </ul>
                        </div>

                    </div>
                </section>
            </div>
        )
    }
}


export default RevAthonMobile;



// WEBPACK FOOTER //
// ./src/components/RevAthonMobile.js